export enum pcsEnrolmentStatusEnum {
    Approved = "AA",
    AwaitingPayment = "AP",
    Declined = "DD",
    Incomplete = "IN",
    Pending = "PD",
    Withdrawn = "WD"
}